module.exports = __webpack_public_path__ + "static/media/border-top.094bd06d.svg";